import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  email: string | null;
  onChange: (name: string, value: any) => void;
};

const makeMapStateToProps = () => {
  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      isVisible: true
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChange: props.onChange
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
